import { useBookingContext } from '@providers/booking/booking_context'
import { useCallback, useEffect, useState } from 'react'
import { SelectRequiredAddons } from './select_required_addons'

export const SelectRequiredAddonsWrapper = ({ enabled }: { enabled: boolean }) => {
  const bookingCtx = useBookingContext()
  const [petIndex, setPetIndex] = useState(0)
  const offerSelected = bookingCtx.state.cart.groups[bookingCtx.state.currentGroup]?.offerSelected

  useEffect(() => {
    // reset pet index when changing group
    // This is needed because each group can have different number of pets and a group cold have one pet only
    // which will make not show the pet inner selector.
    // So we need to reset the pet index to avoid setting offers to wrong pets
    setPetIndex(0)
  }, [bookingCtx.state.currentGroup])

  const onChangeTabHandler = useCallback((_: string, newValue: number) => {
    setPetIndex(newValue)
  }, [])

  if (Boolean(offerSelected?.hasRequiredAddons) && enabled) {
    return <SelectRequiredAddons petIndex={petIndex} onChangeTab={onChangeTabHandler} />
  }

  return null
}
